import Collection from '../Model/Collection';

import { 
  GetSearchResultHeadCells,
  GetSearchResultCardGridItems,
  GetSearchResultTableRows,
} from '../Util/SearchResults';

import SearchResultsCollectionFields from '../Model/SearchResultsCollectionFields';

import {
  GetOrganizationSearchResultsPathForApi,
  GetUserOrganizationSearchResultsPathForApi,
} from '../Util/api';

export class SearchResults_Collection extends Collection {
  constructor(props, context, onSetState, onApiError, contentUriParams) {
    super(props, onSetState, onApiError);

    this.PageTitle = "Search results";
    this.ContentUri = (context.UserPreferences.ActiveOrganizationMember)
      ? GetOrganizationSearchResultsPathForApi(context.UserPreferences.ActiveOrganizationID)
      : GetUserOrganizationSearchResultsPathForApi(context.UserPreferences.ActiveOrganizationID);
    this.ContentUriParams = contentUriParams;
    this.CollectionName = "SearchResults";
    this.ItemsName = "SearchResults";
    this.ItemName = "Search Result";
    this.DefaultViewType = "Card";
    this.AllowSelect = false;
    // this.HideSensitiveFields = true;

    this.context = context;
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(SearchResultsCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => {
    return GetSearchResultHeadCells(items, sensitiveFields);
  }

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, 
    onAction, postActionData, sortType, sortDescending, useSingleColumnLayout, cardStyle) => {
    return GetSearchResultCardGridItems(this.props, this.context, true, false)
      (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction,
        postActionData, sortType, sortDescending, cardStyle);
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return GetSearchResultTableRows(this.props, this.context, true)
      (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, sortType, sortDescending);
  }
}